<div class="cx-cart-coupon-title">
  {{ 'voucher.coupon' | cxTranslate }}
</div>
<div class="form-group">
  <form (ngSubmit)="applyVoucher()" [formGroup]="couponForm">
    <div class="cx-cart-coupon-container">
      <input
        type="text"
        class="form-control input-coupon-code"
        formControlName="couponCode"
        placeholder="{{ 'voucher.placeholder' | cxTranslate }}"
        />
      <button
        class="btn btn-block btn-action apply-coupon-button"
        type="submit"
        [disabled]="cartIsLoading$ | async"
        [class.disabled]="cartIsLoading$ | async"
        >
        {{ 'voucher.apply' | cxTranslate }}
      </button>
      <cx-form-errors
        [control]="couponForm.get('couponCode')"
      ></cx-form-errors>
    </div>
  </form>
</div>

<!-- DRF, if they want to hide applied coupons comment that -->
<cx-applied-coupons
  [vouchers]="cart.appliedVouchers"
  [cartIsLoading]="cartIsLoading$ | async"
  [isReadOnly]="false"
  >
</cx-applied-coupons>

@if (applicableCoupons && applicableCoupons.length > 0) {
}

